import { DialogContent, DialogTitle, Slide } from "@material-ui/core";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import Button from "components/CustomButtons/Button";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import ClientHelper from "core/ClientHelper";
import ResourceHelper from "core/ResourceHelper";
import PropTypes from "prop-types";
import React from "react";
import ButtonToolbar from "views/Components/ButtonToolbar.jsx";
import { GenericCheckInput, GenericDialog, GenericDialogActions, GenericExpansionPanel, GenericGrid, GenericLabel, GenericSelectInput } from "views/Components/Generic";
import { RoleLevel } from "views/Constants/Constant";
import { ParameterEmptyObject } from "views/Constants/Constant.Parameter";
import { SortedCode, SortedFullPath, SortedName } from "views/Constants/Constant.Sorted";

function Transition(props) {
	return <Slide direction="up" {...props} />;
}

class MenuActionRight extends React.Component {
	constructor(props) {
		super(props);

		this.columns = [];

		this.state = {
			model: {
				ParentMenuId: -2
			},
			roleDetails: []
		};
	}

	componentDidMount() {
		const { setAppCenterTitle, setAppLeftTitle } = this.props;

		if (setAppCenterTitle) {
			setAppCenterTitle("USER ADMIN");
		}
		if (setAppLeftTitle) {
			setAppLeftTitle("Menu Action Right");
		}

		var user = ClientHelper.GetUser();

		if (user.Role.RoleLevel.ParameterValue == RoleLevel.ClientStandardUser) {
			this.setState({ isClientStandardUserOpen: true });
		}

		this.GetRoleList();
	}

	ValueChanged = (name, value) => {
		this.setState(state => {
			var model = state.model;
			model[name] = value;

			if (name == "ParentMenuId") {
				model["SubMenuId"] = null;
				model["ActionId"] = null;
			} else if (name == "SubMenuId") {
				model["ActionId"] = null;
			}

			return { model, roleDetails: [] };
		});
	}

	CellValueChanged = (name, value, index, isRole) => {
		var { roleDetails } = this.state;

		if (isRole) {
			roleDetails[index].RoleRight = value;
		} else {
			roleDetails[index].WorkflowRoleRight = value;
		}

		this.setState({ roleDetails });
		this.GetColumns(roleDetails);
	}

	GetColumns = (roleDetails) => {
		this.columns = [
			{
				Header: "Role Name",
				accessor: "RoleName"
			},
			{
				Header: "Role Level",
				accessor: "RoleGroupAndRoleLevel"
			},
			{
				Header: "Role Right",
				Cell: row => (
					<GenericCheckInput
						Name="RoleRight"
						Value={roleDetails[row.index].RoleRight}
						ValueChanged={(name, value) => this.CellValueChanged(name, value, row.index, true)}
					/>
				)
			},
			{
				Header: "Workflow Role Right",
				Cell: row => (
					roleDetails[row.index].IsWorkflowAction &&
					<GenericCheckInput
						Name="WorkflowRoleRight"
						Value={roleDetails[row.index].WorkflowRoleRight}
						ValueChanged={(name, value) => this.CellValueChanged(name, value, row.index, false)}
					/>
				)
			}
		];

		this.forceUpdate();
	}

	GetSubMenuParameter = () => {
		const { model } = this.state;
		var result = {
			Id: model.ParentMenuId
		};

		return result;
	}

	GetRenderItemAction = (x) => {
		var render = `${x.Action.Code} - ${x.Action.Description}`;

		return render;
	}

	GetRoleList = async () => {
		const { model } = this.state;
		const { ExecuteApiPost } = this.props;
		var user = ClientHelper.GetUser();
		var result = await ExecuteApiPost(`/coreapi/v1.0/Role/${user.Role.RoleLevel.ParameterValue != RoleLevel.ClientAdmin ? "Search" : "ListForClientAdmin"}`, model);

		this.setState({ roleList: result || [] });
	}

	GetMenuName(menu) {
		var menuName = ResourceHelper.GetForMenu(menu.Name);
		var menuNameAndCode = `${!menuName ? "! " + menu.Name : menuName} - ${menu.Code}`;

		return menuNameAndCode;
	}

	Search = async () => {
		var { model, roleList } = this.state;
		const { ExecuteApiPost } = this.props;
		var result = await ExecuteApiPost("/coreapi/v1.0/MenuActionRight/GetByMenuIdAndActionId", { MenuId: model.SubMenuId, ActionId: model.ActionId }, null, null, () => this.Validate(false));
		var roleDetails = [];

		if (result != null) {
			roleList
				.map(x => {
					var roleRight = false, workflowRoleRight = false;

					result.RoleIds
						.filter(y => y === x.Id)
						.map(() => {
							roleRight = true;

							return null;
						});

					if (result.IsWorkflowAction) {
						result.WorkflowRoleIds
							.filter(y => y === x.Id)
							.map(() => {
								workflowRoleRight = true;

								return null;
							});
					}

					roleDetails.push({
						"RoleId": x.Id,
						"RoleName": x.RoleName,
						"RoleGroupAndRoleLevel": `${x.RoleGroupParameterDesc} - ${x.RoleLevelParameterDesc}`,
						"IsWorkflowAction": result.IsWorkflowAction,
						"RoleRight": roleRight,
						"WorkflowRoleRight": workflowRoleRight
					});

					return null;
				});

			model["IsParentMenuId"] = false;
			model["IsSubMenuId"] = false;
			model["IsActionId"] = false;

			this.setState({ roleDetails });
			this.GetColumns(roleDetails);
		}
	}

	Submit = () => {
		const { model, roleDetails } = this.state;
		const { ExecuteApiPost } = this.props;

		ExecuteApiPost("/coreapi/v1.0/MenuActionRight/Submit", {
			MenuId: model.SubMenuId, ActionId: model.ActionId,
			WorkflowAndMenuActionRightList: roleDetails.map(x => { return { RoleId: x.RoleId, RoleRight: x.RoleRight, WorkflowRoleRight: x.WorkflowRoleRight }; })
		}, null, null, () => this.Validate(true), null, true);
	}

	Clear = () => {
		this.setState({ model: { ParentMenuId: -2 }, roleDetails: [] });
	}

	Validate = (isSubmit) => {
		var { model, roleDetails } = this.state;
		const { showValidationErrors } = this.props;
		var errors = [];

		if (!model.ParentMenuId || model.ParentMenuId == -2) {
			errors.push("Parent menu can not be null.");
		}
		if (!model.SubMenuId) {
			errors.push("Sub menu can not be null.");
		}
		if (!model.ActionId) {
			errors.push("Action can not be null.");
		}
		if (isSubmit && roleDetails.length == 0) {
			errors.push("Role list can not be null.");
		}

		model["IsParentMenuId"] = !model.ParentMenuId || model.ParentMenuId == -2;
		model["IsSubMenuId"] = !model.SubMenuId;
		model["IsActionId"] = !model.ActionId;

		if (errors.length > 0) {
			showValidationErrors(errors);

			return false;
		}

		return true;
	}

	render() {
		const { model, roleDetails, isClientStandardUserOpen } = this.state;
		const { history, Disabled } = this.props;

		return (
			<div>
				<ButtonToolbar
					ButtonList={[
						{
							Code: "Search",
							Disabled: Disabled,
							OnClick: this.Search
						},
						{
							Code: "Submit",
							Disabled: Disabled,
							OnClick: this.Submit
						},
						{
							Code: "Clear",
							Disabled: Disabled,
							OnClick: this.Clear
						}
					]}
					menuId={this.props.menuId}
					ApprovalData={this.props.ApprovalData}
					After={this.props.After} />
				<GenericDialog open={isClientStandardUserOpen} maxWidth="md" TransitionComponent={Transition}>
					<DialogTitle>
						<GenericLabel Bold Text="Error" />
					</DialogTitle>
					<DialogContent>
						<div style={{ textAlign: "center" }}>
							<GenericLabel Text="You cannot open this screen." />
						</div>
					</DialogContent>
					<GenericDialogActions>
						<Button size="sm" onClick={() => history.push("/")}>OK</Button>
					</GenericDialogActions>
				</GenericDialog>
				<GridContainer spacing={16}>
					<GridItem xs={12}>
						<Card className="no-radius">
							<CardBody>
								<GenericExpansionPanel Title="Menu Action Right">
									<GridContainer>
										<GridItem xs={4}>
											<GenericSelectInput
												Required
												IsInvalid={model.IsParentMenuId}
												Name="ParentMenuId"
												LabelText="Parent Menu"
												LabelMd={3}
												Url="/coreapi/v1.0/Menu/GetMenuListForParentMenu"
												Method="GET"
												Parameter={ParameterEmptyObject}
												DataRoot="Item"
												KeyValueMember="Id"
												TextValueMember="FullPath"
												Sorted={SortedFullPath}
												Value={model.ParentMenuId}
												ValueChanged={this.ValueChanged} />
										</GridItem>
										<GridItem xs={4}>
											<GenericSelectInput
												Required
												IsInvalid={model.IsSubMenuId}
												key={model.ParentMenuId}
												Name="SubMenuId"
												LabelText="Menu"
												LabelMd={2}
												Url="/coreapi/v1.0/MenuAction/GetMenuListByParentMenuId"
												Method="POST"
												Parameter={this.GetSubMenuParameter()}
												DataRoot="Item"
												KeyValueMember="Id"
												RenderItem={this.GetMenuName}
												Sorted={SortedName}
												Value={model.SubMenuId}
												ValueChanged={this.ValueChanged} />
										</GridItem>
										<GridItem xs={4}>
											<GenericSelectInput
												Required
												IsInvalid={model.IsActionId}
												key={model.SubMenuId}
												Name="ActionId"
												LabelText="Action"
												LabelMd={2}
												Url="/coreapi/v1.0/MenuAction/GetByMenuId"
												Method="POST"
												Parameter={model.SubMenuId}
												DataRoot="Item"
												KeyValueMember="ActionId"
												RenderItem={this.GetRenderItemAction}
												Sorted={SortedCode}
												Value={model.ActionId}
												ValueChanged={this.ValueChanged} />
										</GridItem>
									</GridContainer>
								</GenericExpansionPanel>
							</CardBody>
						</Card>
						<Card className="no-radius">
							<CardBody>
								<GridContainer>
									<GridItem xs={12}>
										<GridContainer spacing={16}>
											<GridItem xs={12}>
												<GenericGrid
													HideButton
													Data={roleDetails}
													Columns={this.columns} />
											</GridItem>
										</GridContainer>
									</GridItem>
								</GridContainer>
							</CardBody>
						</Card>
					</GridItem>
				</GridContainer>
			</div >
		);
	}
}

MenuActionRight.propTypes = {
	setAppLeftTitle: PropTypes.func,
	setAppCenterTitle: PropTypes.func,
	ExecuteApiPost: PropTypes.func,
	Disabled: PropTypes.bool,
	menuId: PropTypes.any,
	ApprovalData: PropTypes.any,
	After: PropTypes.any
};

export default MenuActionRight;